import { Reasons } from './Reasons';
import { KeyPoints } from './KeyPoints';
import { HideButtons } from './HideButtons';
import { useLocalization } from '~/framework';
import { ImportantStep } from './ImportantStep';
import { useJIBTableContext } from './JIBTableContext';
import { Table, TableContainer, Thead, Tbody, Tr, Th } from '@chakra-ui/react';

export function JIBTable() {
   const { _js } = useLocalization();
   const { guide, isReasonsColumnVisible, isKeyPointsColumnVisible } = useJIBTableContext();

   return (
      <>
         <HideButtons></HideButtons>
         <TableContainer mt="10px" whiteSpace="normal">
            <Table variant="unstyled" size="lg">
               <Thead background="var(--chakra-colors-gray-100)">
                  <Tr>
                     <Th border="var(--chakra-colors-gray-300) solid 1px" width="33%">
                        {_js('Important Steps')}
                     </Th>
                     {isKeyPointsColumnVisible && (
                        <Th border="var(--chakra-colors-gray-300) solid 1px" width="33%">
                           {_js('Key Points')}
                        </Th>
                     )}
                     {isReasonsColumnVisible && (
                        <Th border="var(--chakra-colors-gray-300) solid 1px" width="33%">
                           {_js('Reasons')}
                        </Th>
                     )}
                  </Tr>
               </Thead>
               <Tbody>
                  {guide?.steps &&
                     guide?.steps.map((step, index) => (
                        <Tr
                           key={index}
                           background={index % 2 ? 'var(--chakra-colors-gray-100)' : 'transparent'}
                        >
                           <ImportantStep importantStep={step} />
                           {isKeyPointsColumnVisible && <KeyPoints keyPoints={step.lines} />}
                           {isReasonsColumnVisible && <Reasons reasons={step.lines} />}
                        </Tr>
                     ))}
               </Tbody>
            </Table>
         </TableContainer>
      </>
   );
}
